import { Component, For, Show } from "solid-js"
import defaultScenario from "../data/scenario/default-scenario.json"
import { vastandeGM } from "../lib/named-scenarios"

interface Template {
    data: any
    name: string
    description: string
}

const SIMULATION_TEMPLATES: Template[] = [
    defaultScenario,
    vastandeGM,
].map((data: any) => ({
    data,
    name: data.meta.name,
    description: `${data.agents?.length ?? 0} aktörer`,
}))

interface RestartModalProps {
    isOpen: boolean
    onClose: () => void
    onSelect: (templateData: any) => void
}

const RestartModal: Component<RestartModalProps> = (props) => {
    const handleSelect = (data: any) => {
        props.onSelect(data)
        props.onClose()
    }

    return (
        <Show when={props.isOpen}>
            {/* Backdrop */}
            <div
                class="fixed inset-0 z-[10000] flex items-end justify-center bg-black/50"
                onClick={props.onClose}
            >
                {/* Sheet - slides up from bottom */}
                <div
                    class="w-full max-w-sm rounded-t-2xl bg-white shadow-xl"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div class="p-5">
                        {/* Handle bar */}
                        <div class="mx-auto mb-4 h-1 w-10 rounded-full bg-gray-300" />

                        <div class="mb-1 flex items-center justify-between">
                            <h2 class="text-lg font-bold text-gray-900">Välj scenario</h2>
                            <button
                                class="rounded-lg p-1 text-gray-400 active:text-gray-600"
                                onClick={props.onClose}
                            >
                                ✕
                            </button>
                        </div>
                        <p class="mb-4 text-sm text-gray-500">Nuvarande scenario ersätts</p>

                        <div class="space-y-3 pb-4">
                            <For each={SIMULATION_TEMPLATES}>
                                {(t) => (
                                    <button
                                        class="flex w-full items-center justify-between rounded-xl border border-gray-200 bg-gray-50 px-4 py-4 text-left transition-colors active:border-blue-400 active:bg-blue-50"
                                        style={{ "-webkit-tap-highlight-color": "transparent" }}
                                        onClick={() => handleSelect(t.data)}
                                    >
                                        <div>
                                            <div class="font-medium text-gray-900">{t.name}</div>
                                            <div class="mt-0.5 text-sm text-gray-500">{t.description}</div>
                                        </div>
                                        <svg
                                            class="h-5 w-5 shrink-0 text-gray-400"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M9 5l7 7-7 7"
                                            />
                                        </svg>
                                    </button>
                                )}
                            </For>
                        </div>
                    </div>
                </div>
            </div>
        </Show>
    )
}

export default RestartModal
